<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.RESET_LINK'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.RESET_LINK'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                    </div>
                </div>
            </div>
            <div class="row">  
                <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.TYPE'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='searchKey' (change)="p=1;getDetail(p)">
                        <option value="" selected hidden disabled><span [translate]="'GREATER.SELECT'"> </span></option>
                        <option value="3"><span [translate]="'GREATER.CREATORS'"> </span></option>
                        <option value="2"><span [translate]="'GREATER.ORGANISATIONS'"> </span></option>
                        <option value="4"><span [translate]="'GREATER.USERS'"> </span></option>
                    </select>                </div>                
                <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>              
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.EMAIL'"> </span></th>  
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span></th> 
                                        <!-- <th scope="col"><span [translate]="'GREATER.FORM'"> </span></th>  -->
                                                                                <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"></span> 
                                           <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>
   
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>                                        
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td>{{item.email}}</td>
                                        <td *ngIf="item.role_info[0].name=='Customer'"><span [translate]="'GREATER.USERS'"> </span></td>
                                        <td *ngIf="item.role_info[0].name!='Customer'">{{item.role_info[0].name}}</td>
                                        <!-- <td>{{service.convertDate(item.updatedAt)}}</td> -->
                                        <td>{{service.convertDate(item.updatedAt)}}</td>
                                        <td *ngIf="item.status == 'Active'" class="text-primary">Pending</td>
                                        <td *ngIf="item.status != 'Active'" class="text-success">Sent</td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example" *ngIf="item.status == 'Active'" >
                                                <button type="button" class="btn btn-success text-center"  (click)="updateStatus(item)">
                                                    <span [translate]="'GREATER.RESET'"> </span>  
                                                </button>                                               
                                            </div>
                                            <div class="btn-group" role="group" aria-label="Basic example" *ngIf="item.status != 'Active'" >
                                                <button type="button" class="btn btn-danger text-center"  (click)="remove(item)">
                                                    <span [translate]="'GREATER.DELETE'"> </span>  
                                                </button>                                               
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>